export default __webpack_public_path__ + "static/media/lesnik_winter_b_04.5ff77e79.svg";